import React, { CSSProperties } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

interface DraggableItemProps {
    item: any;
    renderItem: (_id: string) => React.ReactNode;
};

const DraggableItem = ({ item, renderItem }: DraggableItemProps) => {
	const { attributes, isDragging, listeners, setNodeRef, transform, transition } = useSortable({
		id: item.id,
	});

	const style: CSSProperties = {
		opacity: isDragging ? 0.4 : undefined,
		transform: CSS.Translate.toString(transform),
		transition,
	};

    return (
        <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
            {renderItem(item.id)}
        </div>
    );
};

export default DraggableItem;
